import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoLight from "../../../assets/images/logo-light-vertical.png";

const Home = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <header className="section hero-section" id="home" role="banner">
                <div className="bg-overlay bg-overlay-pattern" aria-hidden="true"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} sm={10}>
                            <div className="text-center mt-lg-5 pt-5">
                                <h1 className="display-6 fw-semibold mb-3 lh-base">
                                    {t('landing.hero.title')}
                                </h1>
                                <div className="d-flex gap-2 mt-4 mb-4 justify-content-center">
                                    <div className="logo">
                                        <img
                                            src={logoLight}
                                            alt={t('landing.hero.logoAlt')}
                                            height="94"
                                            width="auto"
                                            loading="eager"
                                        />
                                    </div>
                                </div>

                                <p className="lead text-muted lh-base">
                                    {t('landing.hero.subtitle')}
                                </p>

                                <nav className="d-flex gap-2 justify-content-center" aria-label={t('landing.hero.mainNav')}>
                                    <Link
                                        to="/admin/login"
                                        className="z-1 btn btn-primary"
                                        title={t('landing.hero.ctaTitle')}
                                    >
                                        {t('landing.hero.cta')} <i className="ri-arrow-right-line align-middle ms-1" aria-hidden="true"></i>
                                    </Link>
                                </nav>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>
        </React.Fragment>
    );
};

export default Home;
